import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatProductCategoryModel } from 'src/app/model/cat-product-category.model';

@Injectable({
  providedIn: 'root'
})
export class CatCategoryProductService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatProductCategory/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatProductCategory/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getByEmployeeJob=(employeeJobId:number)=> {
    return this.http.get(`${this.url}/CatProductCategory/getByEmployeeJob?employeeJobId=${employeeJobId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatProductCategory/List`)
      .pipe(
        map((resp:any)=> resp.filter(cat=> cat.activeId))
      );
  }


  save=(category:CatProductCategoryModel)=> {
    return this.http.post(`${this.url}/CatProductCategory/SaveUpdate`, category)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(category:CatProductCategoryModel)=> {
    return this.http.post(`${this.url}/CatProductCategory/SaveUpdate/${category.productCategoryId}`, category)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
